import { FC } from 'react';
import {
  render,
  StoryblokRichtext,
} from 'storyblok-rich-text-react-renderer-ts';

import { GlossaryLink } from '../../utils/glossary';
import { GlossaryPills } from './GlossaryPills';

interface Props {
  description: StoryblokRichtext;
  onClick?: (link: GlossaryLink) => void;
  relatedTerms: GlossaryLink[];
  title: string;
}

export const GlossaryDetails: FC<Props> = ({
  description,
  onClick,
  relatedTerms,
  title,
}) => (
  <main className="mx-auto flex w-full max-w-lg flex-col space-y-6">
    <div className="aa-prose">{render(description)}</div>
    {relatedTerms.length > 0 && (
      <div className="not-prose">
        <GlossaryPills
          glossary={relatedTerms}
          onClick={onClick}
          title={title}
        />
      </div>
    )}
  </main>
);
